module.exports = __webpack_public_path__ + "static/img/icon-off.72f63fc6.png";